import React, {useEffect, useRef, useContext, useState} from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import columnConfig from './account-policy-run-history.column-config';
import EncDateRangePicker from '../../../../components/date-range-picker/EncDateRangePicker';
import NoResultsMessage from '../../../../components/table-select/NoResultsMessage';
import { Button } from 'semantic-ui-react';
import PageableTableSelect from '../../../../components/table-select/pageable/index';
import { MobXProviderContext } from 'mobx-react';
import { useParams } from 'react-router-dom';

const AccountPolicyRunHistory = observer(() => {
    const { t } = useTranslation();
    const { accountId } = useParams();
    const { headerUIStore, accountStore, policyRunHistoryStore, accountPolicyRunHistoryUIStore } = useContext(MobXProviderContext);
    const tableSelectRef = useRef(null);
    const [tableSelectFilter, setTableSelectFilter] = useState('');

    const setTableSelectRef = (node) => {
        tableSelectRef.current = node;
    };

    useEffect(() => {
        accountStore.retrieveAccount(accountId)
            .then(() => headerUIStore.setTitleKey(accountStore.account.name));

        return () => {
            accountPolicyRunHistoryUIStore.reset();
        };
    }, [accountId, accountStore, accountPolicyRunHistoryUIStore, headerUIStore]);

    const getPageablePolicyRunHistory = (...params) => {
        policyRunHistoryStore.getPageablePolicyRunHistory(accountPolicyRunHistoryUIStore.dateRange, accountId)(...params);
    };

    const exportToCSV = () => {
        policyRunHistoryStore.exportToCsv(
            accountPolicyRunHistoryUIStore.dateRange,
            tableSelectFilter,
            { accountId: accountId, accountName: accountStore.account.name }
        );
    };

    const handleTextFilterChange = filter => {
        if (tableSelectRef.current) {
            setTableSelectFilter(filter);
        }
    };

    const renderAdditionalFilteringComponents = () => (
        <EncDateRangePicker
            startDate={accountPolicyRunHistoryUIStore.dateRange.startDate}
            endDate={accountPolicyRunHistoryUIStore.dateRange.endDate}
            handleRange={dateRange => {
                accountPolicyRunHistoryUIStore.setDateRange(dateRange);
                if (tableSelectRef.current) {
                    tableSelectRef.current.refreshTable();
                }
            }}
        />
    );

    const renderNoResultsMessage = () => (
        <NoResultsMessage
            startDate={accountPolicyRunHistoryUIStore.dateRange.startDate}
            endDate={accountPolicyRunHistoryUIStore.dateRange.endDate}
        />
    );

    return (
        <div className="content sticky-scroll">
            <div className="section__full--width--padding mt-4">
                <Button className="button__primary" onClick={exportToCSV}>
                    {t('common:common.export.to.csv')}
                </Button>
            </div>

            <div className="sticky-scroll">
                <PageableTableSelect
                    multiSelect={false}
                    columnConfig={columnConfig}
                    fetchPageableData={getPageablePolicyRunHistory}
                    rowId="id"
                    isSticky={true}
                    stickyTopOffset={55}
                    stickyTopBarOffset={0}
                    dataName={t('common:common.profiles')}
                    additionalFilteringComponents={renderAdditionalFilteringComponents()}
                    selectable={false}
                    noDataText={renderNoResultsMessage()}
                    defaultColumnSorted="policyDate"
                    tableSelectRef={setTableSelectRef}
                    handleTextFilterChange={handleTextFilterChange}
                />
            </div>
        </div>
    );
});

export default AccountPolicyRunHistory;
